import React, { useState } from 'react';

const INTERESTS = [
  'Handwoven Rugs',
  'Home Decor',
  'Upcycled Jackets',
  'Custom Order',
  'General Inquiry',
];

function Contact() {
  const [form, setForm] = useState({ name: '', email: '', interest: '', message: '' });
  const [status, setStatus] = useState('idle');

  const handleChange = (e) => {
    setForm((prev) => ({ ...prev, [e.target.name]: e.target.value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setStatus('sending');

    try {
      const res = await fetch('https://madesimpl-form-worker.paul4718.workers.dev', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(form),
      });

      if (!res.ok) throw new Error('Send failed');

      setStatus('sent');
      setForm({ name: '', email: '', interest: '', message: '' });
    } catch {
      setStatus('error');
    }
  };

  return (
    <section className="section contact" id="contact">
      <div className="section-header">
        <h2>Send a Note</h2>
        <div className="section-divider" />
      </div>
      <form className="contact-form" onSubmit={handleSubmit}>
        <p className="contact-intro">
          Interested in a custom piece or want to learn more? Fill out the form
          below and I'll get back to you soon. Thank you!
        </p>
        <div className="contact-row">
          <input
            type="text"
            name="name"
            placeholder="Your name"
            value={form.name}
            onChange={handleChange}
            required
          />
          <input
            type="email"
            name="email"
            placeholder="Email address"
            value={form.email}
            onChange={handleChange}
            required
          />
        </div>
        <select
          name="interest"
          value={form.interest}
          onChange={handleChange}
          required
        >
          <option value="" disabled>I'm interested in&hellip;</option>
          {INTERESTS.map((opt) => (
            <option key={opt} value={opt}>{opt}</option>
          ))}
        </select>
        <textarea
          name="message"
          placeholder="Your message"
          rows={5}
          value={form.message}
          onChange={handleChange}
          required
        />
        {status === 'sent' && (
          <p className="contact-status" style={{ color: '#2e7d32' }}>
            Thanks! I'll be in touch soon.
          </p>
        )}
        {status === 'error' && (
          <p className="contact-status" style={{ color: '#c62828' }}>
            Something went wrong. Please try again.
          </p>
        )}
        <button type="submit" disabled={status === 'sending'}>
          {status === 'sending' ? 'Sending\u2026' : 'Send Message'}
        </button>
      </form>
    </section>
  );
}

export default Contact;
